import { FormikHelpers } from 'formik';

import type { YesNoBoolean, YesNoBooleanFormValue } from '@customTypes/form';

import { isObject, isString } from './common';

export const INVALID_FIELD_SELECTOR = '.po-field:has(.po-error)';

export const getFieldError = (fieldErrors: unknown, path: string): string | undefined => {
  const fieldError = path.split('.').reduce((pathErrors, part) => {
    if (isObject(pathErrors)) {
      return pathErrors[part];
    }

    return undefined;
  }, fieldErrors);

  return isString(fieldError) ? fieldError : undefined;
};

export const touchFieldsWithErrors = <TValues = unknown>(
  fieldErrors: object,
  formikHelpers: FormikHelpers<TValues>,
  prefix = '',
): void => {
  Object.entries(fieldErrors).forEach(([key, value]) => {
    const path = prefix ? `${prefix}.${key}` : key;

    if (isObject(value)) {
      touchFieldsWithErrors(value, formikHelpers, path);
      return;
    }

    formikHelpers.setFieldTouched(path, true, false);
  });
};

export const YES_NO_OPTIONS: FormSelectOptions<YesNoBoolean> = [
  { value: 'YES', label: 'Yes' },
  { value: 'NO', label: 'No' },
];

export function convertYesNoToBoolean(value: YesNoBoolean): boolean;
export function convertYesNoToBoolean(value: YesNoBooleanFormValue): boolean | null;
export function convertYesNoToBoolean(value: YesNoBooleanFormValue): boolean | null {
  if (value === 'YES') return true;
  if (value === 'NO') return false;
  return null;
}
